import { useTranslation } from "react-i18next";
import { DocumentMeta } from "@/components/document-meta";
import { LandingNav } from "./sections/landing-nav";
import { HeroSection } from "./sections/hero-section";
import { ProblemSection } from "./sections/problem-section";
import { HowItWorksSection } from "./sections/how-it-works-section";
import { PlatformPreview } from "./sections/platform-preview";
import { OutcomesSection } from "./sections/outcomes-section";
import { FaqSection } from "./sections/faq-section";
import { TrustBar } from "./sections/trust-bar";
import { CtaSection } from "./sections/cta-section";
import { LandingFooter } from "./sections/landing-footer";

/**
 * Main landing page composition component.
 *
 * Renders all sections in order with SEO metadata.
 * All content sourced from i18n.
 * Rosé Pine Dawn luxury tech aesthetic.
 */
export function LandingPage() {
  const { t } = useTranslation();

  return (
    <>
      <DocumentMeta
        title={t("landing.meta.title")}
        description={t("landing.meta.description")}
      />
      <div className="min-h-screen bg-background text-foreground font-sans selection:bg-success/10">
        <LandingNav />
        <main id="top" role="main">
          <HeroSection />
          <ProblemSection />
          <HowItWorksSection />
          <PlatformPreview />
          <OutcomesSection />
          <FaqSection />
          <TrustBar />
          <CtaSection />
        </main>
        <LandingFooter />
      </div>
    </>
  );
}
